import { FunctionComponent, useCallback, useEffect, useState } from 'react';

import { filterBy } from '@progress/kendo-data-query';

import { GroupModel } from 'models';

import { GroupLiteMultiSelect, GroupLiteMultiSelectProps } from '../../group';

/**
 * Wrapper around GroupLiteMultiSelect that handles filtering internally
 * This is needed because Kendo Field component doesn't forward custom props properly
 */
export const FilterableGroupMultiSelect: FunctionComponent<GroupLiteMultiSelectProps> = (props) => {
  const [filteredData, setFilteredData] = useState<GroupModel[]>([]);

  // Update filtered data when original data changes
  useEffect(() => {
    console.log('FilterableGroupMultiSelect: data changed, updating filteredData', props.data.length);
    setFilteredData(props.data.slice());
  }, [props.data]);

  const handleFilterChange = useCallback(
    (event: any) => {
      console.log('FilterableGroupMultiSelect handleFilterChange called', event);
      if (event.filter) {
        const filtered = filterBy(props.data.slice(), event.filter);
        console.log('Filtering data in FilterableGroupMultiSelect', { original: props.data.length, filtered: filtered.length });
        setFilteredData(filtered);
      } else {
        setFilteredData(props.data.slice());
      }
    },
    [props.data],
  );

  return <GroupLiteMultiSelect {...props} data={filteredData} filterable={true} onFilterChange={handleFilterChange} />;
};
